import React, { useState } from 'react';
import { Button, Form, Input, Modal, Spin, message } from "antd";
import { userRegistration } from '../../Services/Services';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
const AddNewLifter = (props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const onFinish = async (values) => {
        setLoading(true);
        Object.assign(values, { 'user_type': 'Lifter','com_name':localStorage.getItem('com_name')})
        const response = await userRegistration(values);
        setLoading(false);
        if (Array.isArray(response)) {
            const filterData = response.filter(o => o.user_type === 'Lifter' && o.com_name === localStorage.getItem('com_name'))
            const sortedArray = [...filterData].sort((a, b) => b.id - a.id);
            message.success('Lifter Creation Successful');
            props.setuserDetails(sortedArray);
            props.setuserList(sortedArray);
            setIsModalOpen(false);
            form.resetFields();
        } else {
            message.warning(response.errors.email[0]);
        }
    };
    const handlePhoneKeyPress = (e) => {
        const charCode = e.which ? e.which : e.keyCode;
        const isNumeric = charCode >= 48 && charCode <= 57; // check if the key pressed is a number
        const isBackspace = charCode === 8; // check if the key pressed is the backspace key
        const phone = e.target.value.replace(/\D/g, ''); // remove all non-numeric characters
        const isValid = phone.length === 10 || isBackspace; // check if the input is a 10-digit number or the backspace key
        if (!isNumeric && !isBackspace) {
            e.preventDefault(); // prevent the input of non-numeric characters
        }

        if (isValid) {
            e.target.value = phone; // update the input value with the valid phone number
        }
    };
    return (
        <>
            <Modal
                open={loading}
                footer={null}
                closable={false}
                width={400}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <img src='transduniyalogo.png' alt='img' width={200} style={{ margin: "10px" }} />

                    <Spin />
                    <h2>Lifter User Creating......</h2>
                </div>
            </Modal>
            <Button onClick={showModal}
                style={{
                     top:'9px',
                    margin: "10px",
                    backgroundColor: 'black',
                    color: 'white',
                    fontWeight: '600'
                }}
            >
                Add New Lifter
            </Button>
            <Modal open={isModalOpen}
                onOk={handleOk} onCancel={handleCancel}
                footer={null}
            >
                <Form
                    form={form}
                    onFinish={onFinish}
                    layout="vertical"
                >
                    <Form.Item
                        name="name"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Lifter Name!",
                            },
                        ]}
                        label={<b>Lifter Name</b>}
                        style={{ padding: "1px", margin: "1px" }}
                    >
                        <Input placeholder="Enter Lifter Name" />
                    </Form.Item>
                    <Form.Item
                        name="email"
                        label={<b>Email</b>}
                        rules={[
                            {
                                type: 'email',
                                message: 'The input is not valid E-mail!',
                            },
                            {
                                required: true,
                                message: 'Please input your E-mail!',
                            },
                        ]}
                        style={{ padding: "1px", margin: "1px" }}
                    >
                        <Input
                            prefix={<UserOutlined className="site-form-item-icon" />}
                            placeholder="Enter Your Email"
                        />
                    </Form.Item>
                    <Form.Item
                        name="gst_no"
                        label={<b>GST No</b>}
                        style={{ padding: "1px", margin: "1px" }}
                    // rules={[
                    //     {
                    //         required: true,
                    //         message: "Please Enter GST No!",
                    //     },
                    // ]}
                    >
                        <Input placeholder="Enter GST No" maxLength={15} minLength={10} />
                    </Form.Item>
                    <Form.Item
                        name="pan_no"
                        label={<b>Pan No</b>}
                        style={{ padding: "1px", margin: "1px" }}
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Pan No!",
                            },
                        ]}
                    >
                        <Input placeholder="Enter Pan No" maxLength={10} minLength={10} />
                    </Form.Item>
                    <Form.Item
                        name="contact_no"
                        label={<b>Contact No</b>}
                        rules={[

                            {
                                required: true,
                                message: "Enter Contact Number"
                            },

                            () => ({
                                validator(_, value) {
                                    if (!value) {
                                        return Promise.reject();
                                    }
                                    if (isNaN(value)) {
                                        return Promise.reject("Phone has to be a number.");
                                    }
                                    if (value.length < 10) {
                                        return Promise.reject(
                                            "Phone number can't be less than 10 digits"
                                        );
                                    }
                                    if (value.length > 10) {
                                        return Promise.reject(
                                            "Phone number can't be more than 10 digits"
                                        );
                                    }
                                    return Promise.resolve();
                                },
                            }),

                        ]}
                        style={{ padding: "1px", margin: "1px" }}
                    >
                        <Input placeholder="Enter Contact No" maxLength={10} minLength={10} onKeyPress={handlePhoneKeyPress} />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        label={<b>Password</b>}
                        rules={[
                            {
                                required: true,
                                message: 'Please Enter  Password!',
                            },
                        ]}
                        style={{ padding: "1px", margin: "1px" }}
                    >
                        <Input.Password
                            prefix={<LockOutlined className="site-form-item-icon" />}
                            placeholder="Password"
                        />
                    </Form.Item>
                    <Form.Item
                        name="password2"
                        label={<b>Confirm Password</b>}
                        dependencies={['password']}
                        hasFeedback
                        rules={[
                            {
                                required: true,
                                message: 'Please Confirm password!',
                            },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('password') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('The new password that you entered do not match!'));
                                },
                            }),
                        ]}
                        style={{ padding: "1px", margin: "1px" }}
                    >
                        <Input.Password
                            prefix={<LockOutlined className="site-form-item-icon" />}
                            placeholder="Confirm Password"
                        />
                    </Form.Item>

                    <Form.Item className="text-center" style={{ textAlign: 'center', padding: "1px", margin: "1px" }}>
                        <Button
                            htmlType="submit"
                            style={{ color: 'white', backgroundColor: 'black', fontSize: 'medium' }}
                        >
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};
export default AddNewLifter;
